<template>
  <div class="right_list_wrap dp_fs_color" :class="{yincang_active: chunjing}">
        <ul class="left-right_list_ul">
      <li class="left-right_list_li">
        <div class="tit">
          联网单位分布
          <span style="position: absolute;right: 20px;top: 9px;font-size: 15px;color: #DC4F4F">单位总数：{{rightTopTotal}}</span>
        </div>
        <div class="tubiao">
          <div class="tubiao_main right_top_wrap">
            <div class="tubiao_box2" id="right_top" v-show="!no_data_status_top"></div>
             <!-- @click="showLayer('rightTop')" -->
            <div class="ani_wrap" v-show="ani_status_top">
              <img :src="tableLoad" /></div>
            <div class="no_data_pic_wrap" :class="{hide_svg: !ani_status_top}" v-show="no_data_status_top">
              <img :src="noData_pic" alt="">
            </div>
          </div>
        </div>
      </li>
      <li class="left-right_list_li">
        <div class="tit">
          {{dateTit}}警情行业分析
        </div>
        <div class="tubiao">
          <div class="tubiao_main right_mid_wrap bd_color echarts_bg_color">
            <ul class="tubiao_tj bd_color">
              <li v-for="(item, index) in mid_nav_arr" :key="index"  :class="[right_mid_ind == index ? `${item.type}active` : '', item.type]" @click='mid_nav_click(index)'>
                {{item.name}}
              </li>
            </ul>
            <div class="tubiao_box1" id='mid_chart'></div>
            <div class="ani_wrap" v-show="ani_status_mid">
              <img :src="tableLoad" /></div>
            <div class="no_data_pic_wrap" :class="{hide_svg: !ani_status_mid}" v-show="no_data_status_mid">
              <img :src="noData_pic" alt="">
            </div>
          </div>
        </div>
      </li>
      <li class="left-right_list_li">
        <div class="tit">
          {{dateTit}}工作
        </div>
        <div class="tubiao">
          <div class="tubiao_main right_bot_wrap bd_color echarts_bg_color">
            <div class="tubiao_box2" id="right_bot" ref="right_bot"></div>
            <div class="ani_wrap" v-show="ani_status_bot">
              <img :src="tableLoad" /></div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import {themeArr} from '@/assets/js/theme.js'
import no_data_pic from '@/assets/img/no_data_pic.png'
import {right_top1, right_mid, right_bot, fx_url, noRes_url} from '@/assets/js/url.js';
import {returnBotData} from '@/assets/js/index.js';
import tableLoad from '@/assets/img/animation.gif';
import right_bot_img2 from '@/assets/img/right_bot_img2.png';
import right_bot_img3 from '@/assets/img/right_bot_img3.png';
import right_bot_img4 from '@/assets/img/right_bot_img4.png';
import right_bot_img5 from '@/assets/img/right_bot_img5.png';
export default {
  name: "",
  data: () => ({
    tableLoad,
    rightTopTotal:0,
    topOption: '',
    midOption: '',
    botOption: '',
    topEchart:'',
    right_mid_chart: '',
    right_bot_chart: '',
    ani_status_top: true,
    ani_status_mid: true,
    ani_status_bot: true,
    no_data_status_top: false,
    no_data_status_mid: false,
    noData_pic: no_data_pic,
    dateTit: '今日',
    // mid_nav_arr: ["火警", "报警", "预警", "隐患", '故障'],
    mid_nav_arr: [
      {name:'火警',type:'hj'},
      {name:'报警',type:'bj'},
      {name:'预警',type:'yj'},
      {name:'隐患',type:'yh'},
      {name:'故障',type:'gz'},
    ],
    right_mid_ind: 0,
    hashValue: '',
    loginData: '',
    right_top_obj:{},
    headData: 0,
    echarts_color: themeArr[0].color,
    botDataArr: [],
  }),
  props:['chunjing', 'headSetaData', 'themeStatus'],
  watch: {
    "themeStatus": function (res) {
      switch (res) {
        case 0:
          this.echarts_color = themeArr[1].color;
          break;
        case 1:
          this.echarts_color = themeArr[0].color;
          break;
      }
      //上图
      for(let i = 0;i < this.topOption.series.length;i++){
        for(let k = 0;k < this.topOption.series[i].data.length;k++){
          this.topOption.series[i].data[k].label.normal.textStyle.color = this.echarts_color;
        }
      }

      this.topOption.tooltip.textStyle.color = this.echarts_color;

      this.topEchart.setOption(this.topOption);
      //中图
      if(this.midOption){
        this.midOption.series[0].label.normal.textStyle.color = this.echarts_color;
        this.midOption.series[0].labelLine.normal.lineStyle.color = this.echarts_color;
        this.midOption.tooltip.textStyle.color = this.echarts_color;
        this.right_mid_chart.setOption(this.midOption);
      }
      //下图
      if(this.botOption){
        this.botOption.xAxis[0].axisLabel.textStyle.color = this.echarts_color;
        this.botOption.yAxis[0].axisLabel.textStyle.color = this.echarts_color;
        this.botOption.tooltip.textStyle.color = this.echarts_color;
        this.right_bot_chart.setOption(this.botOption);
      }

    },
    'headSetaData': function(res){
      console.log(res);
      console.log('头部日期选择');
      this.headData = res;
      switch (res) {
        case 0:
            this.dateTit = '今日';
            break;
        case 1:
            this.dateTit = '本周';
            break;
        case 2:
            this.dateTit = '本月';
            break;
      }
      //右中、右下保持联动
      this.getMidData();
      this.getBotData();
    }
  },
  components: {},
  created() {
    this.hashValue = window.localStorage.getItem('hashValue');
    this.loginData = JSON.parse(window.localStorage.getItem('loginData'));
  },
  computed: {},
  mounted() {
    this.getTopData();
    this.getMidData();
    this.getBotData();
  },
  methods: {
    showLayer(type){
      let obj = {
        status: true,
        type,
        navIndex: '',
      }
      this.$store.commit('showLayer', obj);
    },
    getTopData(){
      this.no_data_status_top = false;
      this.ani_status_top = true;
      let dataObj = {
          type: 'get',
          url: right_top1,
          obj: {
            "orgId": this.loginData.orgId,
          }
      }
      this.$Axios(dataObj).then((res)=>{
        console.log(res);
        console.log('右上角数据');
        this.ani_status_top = false;
        this.rightTopTotal = res.data.data.total
        if(res.data.data.names.length == 0 || res.data.data.names == undefined){
          this.no_data_status_top = true;
        }else{
          this.right_top_obj = res.data.data;
          this.$nextTick(()=>{
            this.rightTopInit(this.right_top_obj);
          });
        }
      }).catch(()=>{
        console.log('右上角数据失败');
        this.no_data_status_top = true;
      });
    },
    getMidData(){
      if(this.right_mid_chart){
        this.right_mid_chart.clear();
      }
      this.no_data_status_mid = false;
      this.ani_status_mid = true;
      let dateType = '';
      let type = '';
      switch (this.headData) {
        case 0:
          dateType = 'thisDay';
          break;
        case 1:
          dateType = 'thisWeek';
          break;
        case 2:
          dateType = 'thisMonth';
          break;
      }
      switch (this.right_mid_ind) {
        case 0:
          type = 'flamingFire';
          break;
        case 1:
          type = 'fire';
          break;
        case 2:
          type = 'warn';
          break;
        case 3:
          type = 'hiddenHazard';
          break;
        case 4:
          type = 'fault';
          break;
      }
      let dataObj = {
          type: 'get',
          url: '/mcbw/warn_stats/alarm',
          obj: {
              "dateType": dateType,
              "type": type,
          }
      }
      this.$Axios(dataObj).then((res)=>{
        console.log(res);
        console.log('右中数据');
        //动画结束
        this.ani_status_mid = false;
        if(res.data.success && res.data.data.length){
          this.rightMidInit(res.data.data);
        }else{
          this.no_data_status_mid = true;
        }
      });
    },
    //右侧下数据
    getBotData(){
      let hiddenDanger = document.getElementsByClassName('hiddenDanger');
      if(hiddenDanger.length>0){
        hiddenDanger[0].remove();
      }
      if(this.right_bot_chart){
        this.right_bot_chart.clear();
      }
      this.ani_status_bot = true;
      let dateType = '';
      switch (this.$store.state.headDate.index) {
          case 0: //日
              dateType = 'thisDay';
              break;
          case 1: //周
              dateType = 'thisWeek';
              break;
          case 2: //月
              dateType = 'thisMonth';
              break;
      }
      let dataObj = {
          type: 'get',
          url: '/mcbw/patrol_stats/patrol',
          obj: {
              "type": dateType,
              "orgId": this.loginData.orgId,
          }
      }
      this.$Axios(dataObj).then((res)=>{
          console.log(res);
          console.log('获取右下数据');
          this.ani_status_bot = false;
          this.botDataArr[0] = this.rightBotReturn(res.data.data.inspectionRate);
          this.botDataArr[1] = this.rightBotReturn(res.data.data.hiddenDangerRate);
          this.botDataArr[2] = [res.data.data.hiddenDangerCount, 100, 0];
          this.botDataArr[3] = this.rightBotReturn(res.data.data.trainingRate);
          this.botDataArr[4] = this.rightBotReturn(res.data.data.rehearsalRate);
          this.rightBotInit(this.botDataArr);
      }).catch((res)=>{
          this.ani_status_bot = false;
      });
    },
    rightMidInit(data){
      // 过滤数据
      let dataCopy = data.concat();
      let dataLength = 0;
      let dataArr = [];
      for(let i = 0; i < dataCopy.length; i++){
        if(!dataCopy[i]['count']){
          dataCopy.splice(i,1);
          dataLength += 1;
        }
      }

      if(dataLength == data.length){ //所有数据都为0
        dataArr = data;
      }else{
        for(let i = 0; i < dataCopy.length; i++){
          if(dataCopy[i]){
            dataArr.push(dataCopy[i]);
          }
        }
      }
      //右中图
      let that = this;
      let option = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
          backgroundColor:"rgba(50, 50, 50, .7)",
          borderColor:"rgba(50, 50, 50, 1)",
          textStyle:{
            color:"#FFFFFF"
          },
          confine: true
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "1%",
          top: "25%",
          containLabel: true
        },
        calculable: false,
        series: [
          {
            name: "警情行业统计",
            type: "pie",
            radius: ["50%", "70%"],
            data: returnBotData(dataArr)
          }
        ]
      };
      this.midOption = option;
      this.right_mid_chart = this.$echarts.init(document.getElementById("mid_chart"));
      this.right_mid_chart.setOption(option);
      this.$emit('right_mid', this.right_mid_chart);
      this.right_mid_chart.off('click');
      this.right_mid_chart.on('click', function (params) {
        let obj = {
            status: true,
            type: 'rightMid',
            navIndex: that.right_mid_ind,
        }
        that.$store.commit('showLayer', obj);
      });
    },
    rightBotReturn(data){
      let arr = [];
      if(data == '~'){
          arr = ['100%', 100, 0];
      }else{
          arr[0] = Math.round(data.replace('%','')) + '%';  //四舍五入

          if(Math.round(data.replace('%','')) >= 100){
              arr[1] = 100;
              arr[2] = 0;
          }else{
              arr[1] = Math.round(data.replace('%',''));
              arr[2] = 100 - arr[1];
          }

      }
      return arr;
    },
    rightBotInit(data) {
      let that = this;
      let res = data;
      console.log("五圈数据")
      console.log(res)
      let colorStyle = {
          normal: {
              color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                      {
                          offset: 0,
                          color: "#158d8f" // 0% 处的颜色
                      },
                      {
                          offset: 1,
                          color: "#352d98" // 100% 处的颜色
                      }
                  ],
                  globalCoord: false // 缺省为 false
              }
          }
      };
      let colorStyle1 = {
          color: {
          x: 1,
          y: 0,
          x2: 1,
          y2: 1,
          "type": "linear",
          "global": false,
          "colorStops": [{
            "offset": 0,
            "color": "#1F5ED3"
          },{
            "offset": 1,
            "color": "#00B7D7"
          }]
        }
      };
      let colorStyle2 = {
          color:"#05243E"
      };
      let option = {
          graphic: [//图形中间图片
              {
                type: "image",
                style: {
                  image: right_bot_img2,//你的图片地址
                  width: 27,
                  height: 19,
                },
                left:'32%',
                top:'13%',
              },
              {
                type: "image",
                style: {
                  image: right_bot_img3,//你的图片地址
                  width: 18,
                  height: 22,
                },
                left:'63%',
                top:'32%',
              },
              {
                type: "image",
                style: {
                  image: right_bot_img4,//你的图片地址
                  width: 26,
                  height: 24,
                },
                left:'45%',
                top:'62%',
              },
              {
                type: "image",
                style: {
                  image: right_bot_img5,//你的图片地址
                  width: 21,
                  height: 29,
                },
                left:'21%',
                top:'81%',
              },
          ],
          title: [
            {
              text:res[0][1]+"%",//主标题文本
              subtext:'巡查完成率',//副标题文本
              left:'45%',
              top:'8%',
              textStyle:{
                fontWeight: 'normal',
                fontSize: 16,
                color:'#00B7D7',
                fontWeight: 500,
                align:'center',
                left:10
              },
              subtextStyle:{
                fontSize: 14,
                color:'#92C2E4',
              }
            },
            {
              text: res[1][1]+"%",//主标题文本
              subtext:'隐患处理率',//副标题文本
              left:'75%',
              top:'27%',
              textStyle:{
                fontWeight: 'normal',
                fontSize: 16,
                color:'#00B7D7',
                align:'center',
                left:10
              },
              subtextStyle:{
                fontSize: 14,
                color:'#92C2E4',
              }
            },
            {
              text: res[3][1]+"%",//主标题文本
              subtext:'培训完成率',//副标题文本
              left:'58%',
              top:'58%',
              textStyle:{
                fontWeight: 'normal',
                fontSize: 16,
                color:'#00B7D7',
                align:'center',
                left:10
              },
              subtextStyle:{
                fontSize: 14,
                color:'#92C2E4',
              }
            },
            {
              text: res[4][1]+"%",//主标题文本
              subtext:'演练完成率',//副标题文本
              left:'33%',
              top:'78%',
              textStyle:{
                fontWeight: 'normal',
                fontSize: 16,
                color:'#00B7D7',
                align:'center',
                left:10
              },
              subtextStyle:{
                fontSize: 14,
                color:'#92C2E4',
              }
            },
          ],
          tooltip: {
            trigger: "item",
            formatter: "{d}%",
            backgroundColor:"rgba(50, 50, 50, .7)",
            borderColor:"rgba(50, 50, 50, 1)",
            textStyle:{
              color:"#FFFFFF"
            }
          },
          series: [
              {
                name: "访问来源",
                type: "pie",
                center : ['35%', '15%'],
                radius: ["20%", "25%"],
                avoidLabelOverlap: false,
                hoverAnination: false,
                label: {
                  normal: {
                      show: true,
                      position: "center",
                      formatter: function(argument) {
                          var html;
                          html = "巡查完成率\n\n" + res[0][1];
                          return html;
                      },
                      textStyle: {
                          color: 'rgba(0,0,0,0)'
                      }
                  }
                },
                labelLine: {
                  normal: {
                    show: false,
                  },
                },
                data: [
                {
                  value: res[0][1],
                  selected:false,
                  name: "巡查完成率",
                  itemStyle: colorStyle1,
                  tooltip: {
                    trigger: "item",
                    formatter: "巡查完成率{d}%",
                    backgroundColor:"rgba(50, 50, 50, .7)",
                    borderColor:"rgba(50, 50, 50, 1)",
                    textStyle:{
                      color:"#FFFFFF"
                    }
                  },
                },
                {
                  value: res[0][2],
                  name: "巡查完成率",
                  itemStyle: colorStyle2,
                  tooltip: {
                    trigger: "item",
                    formatter: "巡查完成率"+res[0][1]+"%",
                    backgroundColor:"rgba(50, 50, 50, .7)",
                    borderColor:"rgba(50, 50, 50, 1)",
                    textStyle:{
                      color:"#FFFFFF"
                    }
                  },
                },
              ]
            },
              // {
              //     name: "访问来源",
              //     type: "pie",
              //     center : ['20%', '25%'],
              //     radius: ["35%", "40%"],
              //     avoidLabelOverlap: false,
              //     hoveranination: false,
              //     // silent: true,
              //     label: {
              //         normal: {
              //             show: true,
              //             position: "center",
              //             formatter: function(argument) {
              //                 var html;
              //                 html = "巡查完成率\n\n" + res[0][0];
              //                 return html;
              //             },
              //             textStyle: {
              //                 fontSize: 12,
              //                 color: that.echarts_color
              //             }
              //         }
              //     },
              //     data: [
              //         { value: res[0][1], name: "巡查完成率",itemStyle: that.botStyle(res[0][1])},
              //         { value: res[0][2], name: "巡查完成率",itemStyle: colorStyle1},
              //     ]
              // },
              {
                  name: "访问来源",
                  type: "pie",
                  center : ['65%', '35%'],
                  radius: ["20%", "25%"],
                  avoidLabelOverlap: false,
                  hoveranination: false,
                  // silent: true,
                  label: {
                    normal: {
                      show: true,
                      position: "center",
                      formatter: function(argument) {
                        var html;
                        html = "隐患处理率\n\n" + res[1][1];
                        return html;
                      },
                      textStyle: {
                        color: 'rgba(0,0,0,0)'
                      }
                    }
                  },
                  data: [
                      {
                        value: res[1][1],
                        name: "隐患处理率",
                        itemStyle:colorStyle1,
                        tooltip: {
                          trigger: "item",
                          formatter: "隐患处理率{d}%",
                          backgroundColor:"rgba(50, 50, 50, .7)",
                          borderColor:"rgba(50, 50, 50, 1)",
                          textStyle:{
                            color:"#FFFFFF"
                          }
                        },
                      },
                      {
                        value: res[1][2],
                        name: "隐患处理率",
                        tooltip: {
                          trigger: "item",
                          formatter: "隐患处理率"+res[1][1]+"%",
                          backgroundColor:"rgba(50, 50, 50, .7)",
                          borderColor:"rgba(50, 50, 50, 1)",
                          textStyle:{
                            color:"#FFFFFF"
                          }
                        },
                        itemStyle: colorStyle2
                      },
                  ]
              },
              // {
              //     name: "访问来源",
              //     type: "pie",
              //     center : ['50%', '50%'],
              //     radius: ["0%", "50%"],
              //     avoidLabelOverlap: false,
              //     hoveranination: false,
              //     // silent: true,
              //     label: {
              //         normal: {
              //             show: true,
              //             position: "center",
              //             formatter: function(argument) {
              //                 var html;
              //                 html = "隐患数量\n\n" + res[2][0];
              //                 return html;
              //             },
              //             textStyle: {
              //                 fontSize: 12,
              //                 color: that.echarts_color
              //             }
              //         }
              //     },
              //     data: [
              //         { value: res[2][1], name: "隐患数量", itemStyle: colorStyle},
              //     ]
              // },
              {
                  name: "访问来源",
                  type: "pie",
                  center : ['48%', '65%'],
                  radius: ["20%", "25%"],
                  avoidLabelOverlap: false,
                  hoveranination: false,
                  // silent: true,
                  label: {
                    normal: {
                      show: true,
                      position: "center",
                      formatter: function(argument) {
                        var html;
                        html = "培训完成率\n\n" + res[3][1];
                        return html;
                      },
                      textStyle: {
                        color: 'rgba(0,0,0,0)'
                      }
                    }
                  },
                  data: [
                      {
                        value: res[3][1],
                        name: "培训完成率",
                        tooltip: {
                          trigger: "item",
                          formatter: "培训完成率{d}%",
                          backgroundColor:"rgba(50, 50, 50, .7)",
                          borderColor:"rgba(50, 50, 50, 1)",
                          textStyle:{
                            color:"#FFFFFF"
                          }
                        },
                        itemStyle: colorStyle1
                      },
                      {
                        value: res[3][2],
                        name: "培训完成率",
                        tooltip: {
                          trigger: "item",
                          formatter: "培训完成率"+res[3][1]+"%",
                          backgroundColor:"rgba(50, 50, 50, .7)",
                          borderColor:"rgba(50, 50, 50, 1)",
                          textStyle:{
                            color:"#FFFFFF"
                          }
                        },
                        itemStyle: colorStyle2
                      },
                  ]
              },
              {
                  name: "访问来源",
                  type: "pie",
                  center : ['23%', '85%'],
                  radius: ["20%", "25%"],
                  avoidLabelOverlap: false,
                  hoveranination: false,
                  // silent: true,
                  label: {
                    normal: {
                      show: true,
                      position: "center",
                      formatter: function(argument) {
                        var html;
                        html = "演练完成率\n\n" + res[4][1];
                        return html;
                      },
                      textStyle: {
                        color: 'rgba(0,0,0,0)'
                      }
                    }
                  },
                  data: [
                      {
                        value: res[4][1],
                        name: "演练完成率",
                        tooltip: {
                          trigger: "item",
                          formatter: "演练完成率{d}%",
                          backgroundColor:"rgba(50, 50, 50, .7)",
                          borderColor:"rgba(50, 50, 50, 1)",
                          textStyle:{
                            color:"#FFFFFF"
                          }
                        },
                        itemStyle: colorStyle1
                      },
                      {
                        value: res[4][2],
                        name: "演练完成率",
                        tooltip: {
                          trigger: "item",
                          formatter: "演练完成率"+res[4][1]+"%",
                          backgroundColor:"rgba(50, 50, 50, .7)",
                          borderColor:"rgba(50, 50, 50, 1)",
                          textStyle:{
                            color:"#FFFFFF"
                          }
                        },
                        itemStyle: colorStyle2
                      },
                  ]
              }
          ]
      };
      this.botOption = option;
      this.right_bot_chart = this.$echarts.init(document.getElementById('right_bot'));
      this.right_bot_chart.setOption(option);
      this.right_bot_chart.off('click');
      this.right_bot_chart.on('click', function(params) {
        let obj = {
            status: true,
            type: 'rightBot',
            navIndex: params.data.name,
        }
        that.$store.commit('showLayer', obj);
      });
      this.$emit('right_bot', this.right_bot_chart);
      let hiddenDanger_div = document.createElement("div");
      hiddenDanger_div.className = "hiddenDanger";
      hiddenDanger_div.innerHTML = "隐患数量";
      let hiddenDanger_span = document.createElement("span");
      hiddenDanger_div.appendChild(hiddenDanger_span);
      hiddenDanger_span.innerHTML = res[2][0];
      document.getElementById('right_bot').appendChild(hiddenDanger_div);
      hiddenDanger_div.onclick = function(){
        let obj = {
          status: true,
          type: 'rightBot',
          navIndex: "隐患数量",
        }
        that.$store.commit('showLayer', obj);
      }
    },
    botStyle(res){
      let colorStyle59 = {
          normal: {
              color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                      {
                          offset: 0,
                          color: "#ee0707" // 0% 处的颜色
                      },
                      {
                          offset: 1,
                          color: "#ef2320" // 100% 处的颜色
                      }
                  ],
                  globalCoord: false // 缺省为 false
              }
          }
      };
      let colorStyle60 = {
          normal: {
              color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                      {
                          offset: 0,
                          color: "#f0720c" // 0% 处的颜色
                      },
                      {
                          offset: 1,
                          color: "#f6600e" // 100% 处的颜色
                      }
                  ],
                  globalCoord: false // 缺省为 false
              }
          }
      };
      let colorStyle80 = {
          normal: {
              color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                      {
                          offset: 0,
                          color: "#ead810" // 0% 处的颜色
                      },
                      {
                          offset: 1,
                          color: "#bea30d" // 100% 处的颜色
                      }
                  ],
                  globalCoord: false // 缺省为 false
              }
          }
      };
      let colorStyle100 = {
          normal: {
              color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                      {
                          offset: 0,
                          color: "#1bdb48" // 0% 处的颜色
                      },
                      {
                          offset: 1,
                          color: "#6ff294" // 100% 处的颜色
                      }
                  ],
                  globalCoord: false // 缺省为 false
              }
          }
      };

      if(res < 60){
          return colorStyle59;
      }else if(res < 80 && res >= 60){
          return colorStyle60;
      }else if(res < 100 && res >= 80){
          return colorStyle80;
      }else if(res == 100){
          return colorStyle100;
      }
    },
    mid_nav_click(nav_index) {
      this.right_mid_ind = nav_index;
      this.getMidData();
    },
    rightTopInit(data) {
      let that = this;
      this.topEchart = this.$echarts.init(document.getElementById("right_top"));
      let option = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
          backgroundColor:"rgba(50, 50, 50, .7)",
          borderColor:"rgba(50, 50, 50, 1)",
          textStyle:{
            color:"#FFFFFF"
          },
          confine: true
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          top: "25%",
          containLabel: true
        },
        calculable: false,
        series: [
          {
            name: "联网单位分布",
            type: "pie",
            // selectedMode: "single",
            radius: ["0%", "30%"],
            label:{
                  formatter:' {b}:{d}%  ',
                  position:'outer',
                  alignTo:'edge',
                  margin:10
              },
            itemStyle: {
              normal: {
                label: {
                  position: "inner"
                },
                labelLine: {
                  show: false
                }
              }
            },
            data: [
              {
                value: data.inside[0].value,
                name: data.inside[0].name,
                itemStyle: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                        {
                            offset: 0,
                            color: "#275D80" // 0% 处的颜色
                        },
                        {
                            offset: 1,
                            color: "#275D80" // 100% 处的颜色
                        }
                    ],
                    globalCoord: false // 缺省为 false
                  }
                },
                label: {
                  normal: {
                    textStyle: {
                      color: "#ffffff"
                    }
                  }
                }
              },
              {
                value: data.inside[1].value,
                name: data.inside[1].name,
                itemStyle: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                        {
                            offset: 0,
                            color: "#8ABADC" // 0% 处的颜色
                        },
                        {
                            offset: 1,
                            color: "#8ABADC" // 100% 处的颜色
                        }
                    ],
                    globalCoord: false // 缺省为 false
                  }
                },
                label: {
                  normal: {
                    textStyle: {
                      color: '#ffffff'
                    }
                  }
                }
              }
            ]
          },
          {
            name: "联网单位分布",
            type: "pie",
            radius: ["40%", "70%"],
            label:false,
            itemStyle: {
              borderRadius: 5,
              borderColor: '#06122C',
              borderWidth: 8
            },
            data: this.return_Top_Fun(data.outside ,1)
          },
          {
            name: "联网单位分布",
            type: "pie",
            radius: ["80%", "90%"],
            itemStyle: {
              borderRadius: 30,
              borderColor: '#06122C',
              borderWidth: 5
            },
            data: this.return_Top_Fun(data.outside ,2)
          }
        ]
      };
      this.topEchart.setOption(option);
      this.topOption = option;
      this.topEchart.on('click',(params)=>{
          console.log(params)
          if(params.name == '其他'){
             this.$store.commit('setNotIndustryCategory', this.right_top_obj.outside[this.right_top_obj.outside.length-1].industryCategory);
          }
          let obj = {
            status: true,
            type:'rightTop',
            navIndex: params.name,
          }
        this.$store.commit('showLayer', obj);
      })
      this.$emit('right_top', this.topEchart);
    },
    return_Top_Fun(data ,type){
      let arr = [];
      let colorOjb = [
        {
          "start": "rgba(0, 183, 215, .2)" ,
          "end": "rgba(0, 183, 215, .2)"
        } ,
        {
          "start": "rgba(233, 159, 86, .2)",
          "end": "rgba(233, 159, 86, .2)"
        },
        {
          "start": "rgba(123, 250, 255, .2)",
          "end": "rgba(123, 250, 255, .2)"
        },
        {
          "start": "rgba(171, 153, 210, .2)",
          "end": "rgba(171, 153, 210, .2)"
        },
        {
          "start": "rgba(255, 255, 255, .2)",
          "end": "rgba(255, 255, 255, .2)"
        },
        {
          "start": "rgba(220, 79, 79, .2)",
          "end": "rgba(220, 79, 79, .2)"
        },
        {
          "start": "#2fc7c9",
          "end": "#1a797a"
        },
        {
          "start": "#97b551",
          "end": "#57682e"
        }
      ];
      let colorOjb2 = [
        {
          "start": "#00B7D7" ,
          "end": "#00B7D7"
        } ,
        {
          "start": "#E99F56",
          "end": "#E99F56"
        },
        {
          "start": "#7BFAFF",
          "end": "#7BFAFF"
        },
        {
          "start": "#AB99D2",
          "end": "#AB99D2"
        },
        {
          "start": "#FFFFFF",
          "end": "#FFFFFF"
        },
        {
          "start": "#DC4F4F",
          "end": "#DC4F4F"
        },
        {
          "start": "#2fc7c9",
          "end": "#1a797a"
        },
        {
          "start": "#97b551",
          "end": "#57682e"
        }
      ];
      for(let i = 0;i<data.length;i++){
        let obj =  {
              value: data[i].value,
              name: data[i].name,
              itemStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: type == 1?colorOjb[i].start:colorOjb2[i].start // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: type == 1?colorOjb[i].end:colorOjb2[i].end // 100% 处的颜色
                    }
                  ],
                  globalCoord: false // 缺省为 false
                }
              },
              label: {
                normal: {
                  textStyle: {
                    color: colorOjb2[i].start,
                  }
                }
              }
            };
        arr.push(obj);
      }
      return arr;
    },
  }
};
</script>
<style lang="scss" scoped>
.right_list_wrap {
  position: absolute;
  bottom: 0;
  right: 0;
  color: #fff;
  //height: calc(100% - 87px);
  height: calc(100% - 120px);
  width: 500px;
  transition: all 1s;
  transform: translateX(0);
  z-index: 10;
}
.yincang_active{
  transform: translateX(100%);
}
.right_top_wrap{
  .no_data_pic_wrap, .ani_wrap{
    height: 100%;
  }
}
.right_mid_wrap{
  .no_data_pic_wrap, .ani_wrap{
    height: calc(100% - 31px);
    top: 31px;
  }
}
.right_bot_wrap{
  .no_data_pic_wrap, .ani_wrap{
    height: calc(100% - 31px);
    top: 31px;
  }
}
.tubiao_main{
  position: relative;
  .sx_nav{
    position: absolute;
    right: 0;
    top: 31px;
    z-index: 10;
    cursor: pointer;
    font-size: 14px;
    display: inline-block;
    span{
      display: inline-block;
      opacity: 0.5;
      &.active{
        opacity: 1;
      }
    }
    span:nth-child(2){
      width: 2px;
      height: 10px;
    }
  }
}
.hj{
  color: #CE0000 !important;
}
.hjactive{
  position: relative;
}
.hjactive::after {
  content:"";
  display: block;
  position: absolute;
  width: 40px;
  left: 50%;
  transform: translateX(-50%);
  bottom: 0;
  border-bottom:4px solid #CE0000;
}
.bj{
  color: #FF0000 !important;
}
.bjactive {
  position: relative;
}
.bjactive::after {
  content:"";
  display: block;
  position: absolute;
  width: 40px;
  left: 50%;
  transform: translateX(-50%);
  bottom: 0;
  border-bottom:4px solid #CE0000;
}
.yj{
  color: #FF6600 !important;
}
.yjactive {
  position: relative;
}
.yjactive::after {
  content:"";
  display: block;
  position: absolute;
  width: 40px;
  left: 50%;
  transform: translateX(-50%);
  bottom: 0;
  border-bottom:4px solid #FF6600;
}
.yh{
  color: #FFFF99 !important;
}
.yhactive {
  position: relative;
}
.yhactive::after {
  content:"";
  display: block;
  position: absolute;
  width: 40px;
  left: 50%;
  transform: translateX(-50%);
  bottom: 0;
  border-bottom:4px solid #FFFF99;
}
.gz{
  color: #FFCC00 !important;
}
.gzactive {
  position: relative;
}
.gzactive::after {
  content:"";
  display: block;
  position: absolute;
  width: 40px;
  left: 50%;
  transform: translateX(-50%);
  bottom: 0;
  border-bottom:4px solid #FFCC00;
}
</style>



// WEBPACK FOOTER //
// src/components/rightList.vue